<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          ><span class="local">你的位置</span></el-breadcrumb-item
        >
        <el-breadcrumb-item>代付模块</el-breadcrumb-item>
        <el-breadcrumb-item>黑名单列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-alert show-icon="">
      <template #title>
        <div class="title">什么是黑名单？</div>
      </template>
      <div class="desc">
        <p>1、支付宝黑名单：黑名单中的支付宝帐号，无法自动秒提，只能手动秒提</p>
        <p>2、角色名黑名单：黑名单中的角色名，无法自动秒提，只能手动秒提</p>
        <p>
          3、永久黑名单：黑名单中的支付宝帐号，无法自动秒提，也无法手动秒提，只能私下转账
        </p>
        <p>黑名单数据为所有版本共用数据，请谨慎添加！</p>
      </div>
    </el-alert>
    <div class="search-box">
      <div class="item">
        商户ID：
      </div>
      <div class="item w1">
        <el-input
          size="small"
          suffix-icon="el-icon-arrow-down"
          v-model="form.Id"
        ></el-input>
      </div>
      <div class="item">
        账户或角色：
      </div>
      <div class="item w1">
        <el-input
          size="small"
          suffix-icon="el-icon-arrow-down"
          v-model="form.Name"
        ></el-input>
      </div>
      <div class="item">
        <el-select
          placeholder="请选择"
          size="small"
          v-model="form.PaidBlacklistType"
        >
          <el-option :value="0" label="全部"> </el-option>
          <el-option :value="1" label="支付宝黑名单"> </el-option>
          <el-option :value="2" label="角色名黑名单"> </el-option>
          <el-option :value="3" label="永久名黑名单"> </el-option>
        </el-select>
      </div>
      <div class="item">
        <el-button type="danger" size="small" @click="search">查询</el-button>
        <el-button size="small" @click="reset">重置</el-button>
        <el-button size="small" @click="$router.push('/home/blackListAdd')"
          >新增</el-button
        >
      </div>
    </div>
    <!-- <div class="tips">
      商户累计总额<font color="#ff0000">0</font>元, 秒提总额<font
        color="#ff0000"
        >0</font
      >元, 今日总额<font color="#ff0000">0</font>元
    </div> -->
    <el-table
      ref="singleTable"
      :data="tableData"
      highlight-current-row
      border
      style="width: 100%"
    >
      <el-table-column type="index" width="50" align="center">
      </el-table-column>
      <el-table-column property="id" label="商户ID" align="center">
      </el-table-column>
      <el-table-column property="name" label="账户或角色" align="center">
      </el-table-column>
      <el-table-column
        property="paidBlacklistType"
        label="选择类型"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.paidBlacklistType == 0">全部</span>
          <span v-if="scope.row.paidBlacklistType == 1">支付宝黑名单</span>
          <span v-if="scope.row.paidBlacklistType == 2">角色名黑名单</span>
          <span v-if="scope.row.paidBlacklistType == 3">永久名黑名单</span>
        </template>
      </el-table-column>
      <!-- <el-table-column property="name" label="添加时间" align="center"> </el-table-column> -->
      <el-table-column property="remarks" label="备注" align="center">
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="confirm_del(scope.$index, scope.row)"
            >移除黑名单</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="mgt15 mgb15 mgl15 mgr15" style="text-align: center;">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="form.total"
        :current-page="form.PageNumber"
        :page-size="form.PageSize"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
    <!-- 自由账户配置 -->
    <el-dialog title="自由账户配置" :visible.sync="dialogConfig">
      <el-table
        ref="singleTable"
        :data="tableData"
        highlight-current-row
        border
        style="width: 100%"
        size="small"
      >
        <el-table-column type="index" width="50" align="center">
        </el-table-column>
        <el-table-column property="name" label="修改前" align="center">
        </el-table-column>
        <el-table-column property="name" label="修改后" align="center">
        </el-table-column>
        <el-table-column property="name" label="修改时间" align="center">
        </el-table-column>
        <el-table-column property="name" label="操作人" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import mgr from '../../assets/js/securityapi';
import api from '../../assets/js/apiRequestHandler';
export default {
  data() {
    return {
      dialogConfig: false,
      tableData: [],
      form: {
        Id: '',
        ApplicationUserId: '',
        Name: '',
        PaidBlacklistType: 0,
        PageNumber: 1,
        PageSize: 10,
        total: 0
      }
    };
  },
  created() {
    this.getLists();
  },
  methods: {
    async getLists() {
      let header = await mgr();
      for (let i in this.form) {
        if (this.form[i] === '') {
          delete this.form[i];
        }
      }
      api
        .get('/api/Paid/GetBlacklists', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: this.form
        })
        .then(res => {
          if (res.status === 200) {
            this.form.total = JSON.parse(
              res.headers['x-pagination']
            ).TotalCount;
            this.tableData = res.data;
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    search() {
      this.tableData = [];
      this.form.PageNumber = 1;
      this.getLists();
    },
    changePage(page) {
      console.log(page);

      this.form.PageNumber = page;
      this.getLists();
    },
    reset() {
      this.form = {
        Id: '',
        ApplicationUserId: '',
        Name: '',
        PaidBlacklistType: 0,
        PageNumber: 1,
        PageSize: 10,
        total: 0
      };
      this.tableData = [];
      this.getLists();
    },
    confirm_del(index, row) {
      this.$confirm('此操作将移除黑名单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.del(index, row);
        })
        .catch(() => {});
    },
    async del(index, row) {
      let header = await mgr();
      api
        .get('/api/Paid/DeletePaidBlacklist', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: {
            blacklistId: row.id
          }
        })
        .then(res => {
          if (res.status === 200) {
            this.$messageSuccess(res.data);
            this.tableData.splice(index, 1);
          } else {
            this.$messageSuccess(res.data);
          }
        })
        .catch(err => {
          console.log(err);
          this.$messageError(err);
        });
    }
  }
};
</script>
<style>
.el-alert__icon {
  margin: 0 15px;
  color: rgb(235, 138, 17);
}
</style>
<style scoped>
.gs_container {
  background-color: #fff;
}

.title {
  color: rgb(92, 184, 92);
  font-size: 24px;
  margin: 15px 0;
}

.desc {
  color: rgb(92, 184, 92);
  line-height: 22px;
}
</style>
